import React from 'react'
import './about.css'

import { FiAward } from 'react-icons/fi'
import { FiUsers } from 'react-icons/fi'
import { BsFolderPlus } from 'react-icons/bs'

import AboutImg from '../../../assets/images/ME.png';
import CTA from '../../shared/ui/CTA'
import REZ from '../../../assets/images/julio_vargas_resume.pdf'

const About = () => {
  return (
    <section id="about">
      <div className='container about__container'>
        <div className="about__me">
          <div className="about__img">
            <img src={AboutImg} alt="Me" />
          </div>
        </div>

        <div className="about__content">
          <p>
            I’m a Front-End Web Developer with a passion for creating clean, responsive, and user-friendly websites. I specialize in turning design concepts into interactive digital experiences using modern technologies like HTML, CSS, JavaScript, and frameworks such as React and WordPress. I focus on performance, accessibility, and delivering polished interfaces that work seamlessly across all devices.
          </p>
          <div className="about__cards">
            <article className='about__card'>
              <FiAward className='about__icon' />
              <h5>Experience</h5>
              <small>20+ Years </small>
            </article>

            <article className='about__card'>
              <FiUsers className='about__icon' />
              <h5>Clients</h5>
              <small>Fortune 500 / 100 </small>
            </article>

            <article className='about__card'>
              <BsFolderPlus className='about__icon' />
              <h5>Projects</h5>
              <small>80+ Completed</small>
            </article>
          </div>

          <div className='download-cta'>
            <CTA class="btn" text="Download Resume" link={REZ} window='new' />
            {/* <CTA class="btn btn-primary" text="Contact" link="#contact"/> */}
          </div>

        </div>

      </div>

    </section>
  )
}

export default About